import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from './reducers/rootReducer';
import {
    LogAndCrashReporter,
    scorecardsMiddleware,
    clausesMiddleware,
    mixpanelMiddleware
} from './middleware';

const { createLogger } = require('redux-logger');

let middleware = null;

if (
    process.env.NODE_ENV === 'development' &&
    !(
        navigator.appName === 'Microsoft Internet Explorer' ||
        !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/))
    )
) {
    middleware = applyMiddleware(
        thunkMiddleware,
        createLogger({
            collapsed: true,
            duration: true,
            diff: false
        }),
        LogAndCrashReporter,
        scorecardsMiddleware,
        clausesMiddleware,
        mixpanelMiddleware
    );
} else {
    middleware = applyMiddleware(
        thunkMiddleware,
        LogAndCrashReporter,
        scorecardsMiddleware,
        clausesMiddleware,
        mixpanelMiddleware
    );
}

export default createStore(rootReducer, middleware);
